<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        

        <div class="col-12">
                <div class="row">
                  <div class="col-md-3">
                    <div class="card">
                    <div class="card-body p-2">
                      <div class=" mb-2 d-flex justify-content-between">
                        <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-undo"></i> back</a></span>
                        <img class="img-rounded" src="@/assets/images/insurancelogo1.png" height="70px" />
                        <span><router-link :to="{ path: '/printaccountledger',  query: { id: this.$route.query.id}}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-printer"></i> Print</router-link></span>
                      </div>
                          <table class="table">
  
                      <tr><td> Name </td><td> <b class="text-primary h7">{{ groups.acc_name}} </b></td></tr>
                    </table>
                    </div>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="col-md-8" style="font-family:Arial, Helvetica, sans-serif;">
                        <div v-if="userData && userData.settings && userData.settings.print_trans == '1'">
                      <span v-if="ledger.length">
                      <h5> Payment Details</h5>
                        <table class="table table-sm mt-2" style="color: black;" density="compact">
                        <thead><tr><th> ID</th><th> Name</th><th>Category</th><th>Service Name</th><th>Service Price</th><th>Prescription</th></tr></thead>
                        <tbody>
                          <tr v-for="item in ledger" :key="item.id">
                              <td>{{ item.patient_id }} </td>
                              <td>{{ item.patient_name }} </td>
                              <td>{{ item.service_category }} </td>
                              <td>{{ item.service_name }}</td>
                              <td>{{ item.price }}</td>
                              <td>{{  item.prescription }}</td>
                          </tr>
                        </tbody>
                        </table>

                       
                      </span>
                      
                     
                    
                    </div>
                    <div v-else>
                      <span v-if="ledger.length">
                      <h5>Details</h5>
                        <table class="table table-sm mt-2" style="color: black;" density="compact">
                        <thead><tr><th> ID</th><th> Name</th><th>Category</th><th>Service Name</th><th>Service Price</th><th>Prescription</th></tr></thead>
                        <tbody>
                          <tr v-for="item in ledger" :key="item.id">
                              <td>{{ item.patient_id }} </td>
                              <td>{{ item.patient_name }} </td>
                              <td>{{ item.service_category }} </td>
                              <td>{{ item.service_name }}</td>
                              <td>{{ commas(item.price) }}</td>
                              <td>{{  item.prescription }}</td>
                          </tr>
                        </tbody>
                        </table>
                      </span>
        
           
            
          <span v-if="payments.length">
        <h5 >Payments</h5>
          <table class="table table-sm mt-n2" style="color: black;" density="compact">
          <thead><tr><th>Pay Date</th><th>Amount Paid Time</th><th>Discount</th><th>Payment Type</th></tr></thead>
          <tbody>
            <tr v-for="item in payments" :key="item.id">
                <td>{{ item.pay_date }}</td>
                <td>{{ commas(item.amount_paid) }}</td>
                <td>{{ commas(item.amount_discount) }}</td>
                <td>
                  <span v-if="item.payment_type==1">Cash</span>
                  <span v-else>Account</span>
                </td>
            </tr>
          </tbody>
          </table>
          </span>
        </div>
                      <div class="d-flex justify-content-between">
                        <span class="h5 text-black"> Total Amount: <span class="text-primary h2">{{ commas(totalAmountPrice) }}</span></span>
                        
                      </div>
    
                    
    
                  </div>
                  
                  </div>
             
             
             
                </div>
       
              </div>
      </div>
      
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { paymentoptionComputed, paymentoptionMethods, groupaccountMethods, groupaccountComputed,groupaccountinvoiceMethods, groupaccountinvoiceComputed } from "@/state/helpers";

  
  export default {
    page: {
      title: "Group Account Ledger",
      meta: [{name: "description",content: appConfig.description,},],
    },
    components: {
      Layout,
      PageHeader,
    },
   
    data() {
      return {
        title: "Payment Ledger",
        items: [{text: "Dashboard",to: "/",},{text: "Patients",active: true,},],
        userData: JSON.parse(localStorage.getItem("user")),
        insurances:[],
        companyid:'',
        ledger:[],
        ledgers:[],
        groups:[],
        acc_name:'',
      };
    },
    created() {
      // this.showgroup();
      this.fetchGroupAccounts();
      this.fetchInfo();
      
    },
    // computed:{
    //   totalServicePrice() {
        
    //     return this.ledger.reduce((total, item) => total + item.price, 0);
    //   },
    //   totalPresciptionsPrice() {
        
    //     return this.prescriptions.reduce((total, prescription) => total + prescription.totalprice, 0);
    //   },
     
     
    //   totalAmountPrice(){
    //     return this.totalServicePrice
    //   },
    
    // }
    computed: {
      ...groupaccountComputed,
      ...groupaccountinvoiceComputed,
      ...paymentoptionComputed,
    totalServicePrice() {
      return this.ledger.reduce((total, item) => total + Number(item.price || 0), 0);
    },
    totalPresciptionsPrice() {
      return this.ledger.reduce((total, item) => total + Number(item.prescription || 0), 0);
    },
    totalAmountPrice() {
      return this.totalServicePrice + this.totalPresciptionsPrice;
    }
  },
    methods: {
      ...groupaccountMethods,
      ...groupaccountinvoiceMethods,
      ...paymentoptionMethods,
      commas(x) { return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
  
      
      async fetchInfo(){
        this.id=this.$route.query.id;
        let url = `/accountledger/${this.id}`;
        await axios.get(url).then((response) => {
          this.ledger = response.data.ledgers;
          if (response.data.ledgers.length > 0) {
          this.groups = response.data.ledgers[0].group;
        }
          // this.showgroup();
          
        });
      },
      // async showgroup(){
      
      //   this.companyid = this.$route.query.id;
      //   let url = `/insurancecompanyprofile/${this.companyid}`;
  
      //   await axios.get(url).then((response) => {
      //     this.insurances = response.data.insurancecompany;
      //     this.insurancespinner=false;
      //   });
      // },
    
    },
  };
  </script>